module.exports = __webpack_public_path__ + "static/ccm_og_image-102d889491da789a23a851d20d0e71e6.jpg";